import classes from "./Loader.module.css";

const Loader = ({ white }: {white?: boolean}) => {

    const classList =  white ? classes.lds_roller + ' ' + classes.lds_roller_white_dots : classes.lds_roller




  return (
    <div className={classList}>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  );
};

export default Loader;
